import api from "../../../utils/axiosInstance";
import { toast } from "../../../components/Toast/toast";

export const TYPE_STYLES = {
  "In-House": "border-l-2 border-sky-400",
  Freelance: "border-l-2 border-emerald-400",
  Company: "border-l-2 border-amber-400",
};

const TYPE_BADGE = {
  "In-House": "bg-sky-50 text-sky-700",
  Freelance: "bg-emerald-50 text-emerald-700",
  Company: "bg-amber-50 text-amber-700",
};

const STATUS_BADGE = {
  new: { label: "New", cls: "bg-brand-50 text-brand-700" },
  accepted: { label: "Accepted", cls: "bg-emerald-50 text-emerald-700" },
  rejected: { label: "Rejected", cls: "bg-gray-100 text-gray-600" },
};

export const TypeBadge = ({ type }) =>
  type ? (
    <span
      className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${
        TYPE_BADGE[type] || "bg-gray-100 text-gray-700"
      }`}
    >
      {type}
    </span>
  ) : (
    <span className="text-gray-500">—</span>
  );

export const StatusBadge = ({ status }) => {
  const badge = STATUS_BADGE[status] || STATUS_BADGE.new;
  return (
    <span className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${badge.cls}`}>
      {badge.label}
    </span>
  );
};

export const applicantName = (a) => `${a.first_name || ""} ${a.last_name || ""}`.trim();

export const applicationCode = (a) => `APP-${String(a.id).padStart(3, "0")}`;

export const formatDate = (value) => (value ? new Date(value).toLocaleDateString() : "—");

export const downloadApplicationFile = async (file) => {
  try {
    const res = await api.get("/download-file", {
      params: { path: file.file_path },
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: file.mime_type || undefined }));
    const link = document.createElement("a");
    link.href = url;
    link.download = file.file_name;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch {
    toast.error("Could not download the file.");
  }
};

// The dialog frame shared by the application view and accept dialogs.
export const Dialog = ({ title, onClose, children, footer, wide = false }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/40 p-4">
    <div
      className={`flex max-h-[90vh] w-full flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-pop ${
        wide ? "max-w-3xl" : "max-w-md"
      }`}
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
        <h2 className="text-sm font-semibold tracking-tight text-gray-900">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg p-1 text-lg leading-none text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
      {footer && (
        <div className="flex justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-5 py-3">
          {footer}
        </div>
      )}
    </div>
  </div>
);
